
  'use strict';

  const readMoreButtons = document.querySelectorAll('.read-more-button');
  
  readMoreButtons.forEach((button) => {
    console.log('clicked');
    button.addEventListener('click', function() {
      const section = button.closest('.text-section');
      const bottomContent = section.querySelector('.bottom-content'); 

      bottomContent.classList.toggle('hide');

      // Toggle the button text based on current state
      if (button.textContent == "Read more") {
        button.textContent = "Read less";
      } else {
        button.textContent = "Read more";
      }
    });
  });

